import React from "react";

export const SatisfactionShield = () => (
  <svg
    width="257.616"
    height="209.42816"
    viewBox="0 0 257.616 209.42816"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 224.364,9.469086 V 127.80816 c 0,26.407 -17.508,49.612 -42.9,56.861 l -53.556,15.289 -53.5557,-15.289 c -25.3919,-7.249 -42.8998,-30.454 -42.8998,-56.861 V 9.469086 Z M 224.364,0 H 31.4537 C 26.2231,0 21.9834,4.239696 21.9834,9.470336 V 127.80916 c 0,15.032 4.7851,29.319 13.8386,41.318 9.0534,11.998 21.4779,20.521 35.9318,24.648 l 53.5562,15.288 c 0.849,0.243 1.724,0.365 2.599,0.365 0.875,0 1.75,-0.121 2.6,-0.365 l 53.556,-15.288 c 14.454,-4.127 26.878,-12.65 35.932,-24.648 9.053,-11.999 13.838,-26.287 13.838,-41.318 V 9.470336 C 233.834,4.239696 229.594,0 224.364,0 Z"
      fill="var(--brand-700)"
      id="path1"
    />
    <path
      d="M 218.123,15.709056 V 127.80816 c 0,23.496 -15.779,44.41 -38.372,50.86 l -51.843,14.799 -51.8423,-14.799 c -22.5925,-6.45 -38.3718,-27.364 -38.3718,-50.86 V 15.709056 Z m 6.24,-6.24031 H 31.4536 V 127.80816 c 0,26.406 17.5079,49.612 42.8998,56.86 l 53.5556,15.289 53.556,-15.289 c 25.392,-7.248 42.9,-30.454 42.9,-56.86 V 9.468746 Z"
      fill="#dbeefc"
      id="path2"
    />
    <path
      d="M 248.237,125.03516 H 9.37849 c -5.1768,0 -9.37311891,-3.76 -9.37311891,-8.399 V 66.594856 c 0,-4.6391 4.19631891,-8.3995 9.37311891,-8.3995 H 248.237 c 5.177,0 9.373,3.7604 9.373,8.3995 v 50.041304 c 0,4.639 -4.196,8.399 -9.373,8.399 z"
      fill="#f77add"
      id="path3"
    />
    <path
      d="M 93.5097,58.198556 18.9245,125.03516 H 9.38148 C 4.20746,125.03516 0,121.27816 0,116.64016 v -3.861 L 60.9072,58.197256 h 32.6025 z"
      fill="#ff8ae6"
      id="path4"
    />
    <path
      d="M 198.262,58.197256 123.678,125.03416 H 68.0615 L 142.645,58.197256 Z"
      fill="#ff8ae6"
      id="path5"
    />
    <path
      d="m 257.616,66.590556 v 14.5424 l -48.99,43.901204 h -40.677 l 74.584,-66.836904 h 5.701 c 5.174,0 9.382,3.7567 9.382,8.3933 z"
      fill="#ff8ae6"
      id="path6"
    />
    <path
      d="m 196.041,35.866756 c 0,2.2478 -1.822,4.07 -4.07,4.07 -2.247,0 -4.07,-1.8222 -4.07,-4.07 0,-2.2477 1.823,-4.0699 4.07,-4.0699 2.248,0 4.07,1.8222 4.07,4.0699 z"
      fill="var(--brand-700)"
      id="path7"
    />
    <path
      d="m 213.061,35.866756 c 0,2.2478 -1.822,4.07 -4.07,4.07 -2.247,0 -4.07,-1.8222 -4.07,-4.07 0,-2.2477 1.823,-4.0699 4.07,-4.0699 2.248,0 4.07,1.8222 4.07,4.0699 z"
      fill="var(--brand-700)"
      id="path8"
    />
    <path
      d="m 59.7764,35.866756 c 0,2.2478 1.8221,4.07 4.0699,4.07 2.2478,0 4.0699,-1.8222 4.0699,-4.07 0,-2.2477 -1.8221,-4.0699 -4.0699,-4.0699 -2.2478,0 -4.0699,1.8222 -4.0699,4.0699 z"
      fill="var(--brand-700)"
      id="path9"
    />
    <path
      d="m 42.7563,35.866756 c 0,2.2478 1.8222,4.07 4.07,4.07 2.2478,0 4.0699,-1.8222 4.0699,-4.07 0,-2.2477 -1.8221,-4.0699 -4.0699,-4.0699 -2.2478,0 -4.07,1.8222 -4.07,4.0699 z"
      fill="var(--brand-700)"
      id="path10"
    />
    <path
      d="m 129.715,146.71616 3.351,6.791 c 0.294,0.594 0.86,1.006 1.517,1.102 l 7.494,1.089 c 1.653,0.24 2.312,2.27 1.116,3.436 l -5.423,5.286 c -0.474,0.463 -0.691,1.129 -0.579,1.782 l 1.281,7.465 c 0.282,1.645 -1.444,2.899 -2.922,2.123 l -6.703,-3.525 c -0.587,-0.308 -1.288,-0.308 -1.875,0 l -6.703,3.525 c -1.478,0.776 -3.205,-0.478 -2.922,-2.123 l 1.281,-7.465 c 0.112,-0.653 -0.105,-1.32 -0.58,-1.782 l -5.422,-5.286 c -1.196,-1.166 -0.536,-3.195 1.115,-3.436 l 7.495,-1.089 c 0.657,-0.095 1.223,-0.508 1.516,-1.102 l 3.353,-6.791 c 0.736,-1.497 2.872,-1.497 3.61,0 z"
      fill="var(--brand-700)"
      id="path11"
    />
    <path
      d="m 89.4303,136.95516 2.46,4.985 c 0.2159,0.436 0.6315,0.739 1.1133,0.809 l 5.5014,0.8 c 1.2119,0.176 1.696,1.666 0.8188,2.521 l -3.9801,3.88 c -0.3482,0.34 -0.508,0.829 -0.4256,1.308 l 0.9398,5.479 c 0.2072,1.208 -1.0609,2.128 -2.1454,1.559 l -4.9199,-2.586 c -0.4306,-0.227 -0.9448,-0.227 -1.3754,0 l -4.9199,2.586 c -1.0845,0.57 -2.3526,-0.351 -2.1454,-1.559 l 0.9398,-5.479 c 0.0824,-0.479 -0.0774,-0.968 -0.4256,-1.308 l -3.9801,-3.88 c -0.8774,-0.855 -0.3931,-2.345 0.8188,-2.521 l 5.5014,-0.8 c 0.4818,-0.07 0.8974,-0.372 1.1133,-0.809 l 2.46,-4.985 c 0.5416,-1.099 2.1079,-1.099 2.6508,0 z"
      fill="var(--brand-700)"
      id="path12"
    />
    <path
      d="m 166.387,136.95516 -2.46,4.985 c -0.215,0.436 -0.631,0.739 -1.113,0.809 l -5.501,0.8 c -1.212,0.176 -1.696,1.666 -0.819,2.521 l 3.98,3.88 c 0.348,0.34 0.508,0.829 0.426,1.308 l -0.94,5.479 c -0.207,1.208 1.061,2.128 2.145,1.559 l 4.92,-2.586 c 0.431,-0.227 0.945,-0.227 1.375,0 l 4.92,2.586 c 1.085,0.57 2.353,-0.351 2.146,-1.559 l -0.94,-5.479 c -0.082,-0.479 0.077,-0.968 0.426,-1.308 l 3.98,-3.88 c 0.877,-0.855 0.393,-2.345 -0.819,-2.521 l -5.502,-0.8 c -0.481,-0.07 -0.897,-0.372 -1.113,-0.809 l -2.46,-4.985 c -0.541,-1.099 -2.108,-1.099 -2.651,0 z"
      fill="var(--brand-700)"
      id="path13"
    />
    <text
      x="50%"
      y="44.26078"
      textAnchor="middle"
      className="text-2xl font-bold"
    >
      <tspan x="50%" y="44.26078" fill="var(--brand-700)">
        100%
      </tspan>
    </text>
    <text x="50%" y="101.30341" className="text-3xl" textAnchor="middle">
      <tspan x="50%" y="101.30341" fill="white">
        SATISFACTION
      </tspan>
    </text>
  </svg>
);
